/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import {
  Box,
  Grid,
  Dialog,
  Divider,
  TextField,
  InputLabel,
  Typography,
  FormControl,
  DialogActions,
  DialogContent
} from '@mui/material';
import CommonModalHeader from '../../../../../components/DialogUi/CommonModalHeader';
import { GroupBasedRoleFormatter } from '../../../components/common';
import DosenButton from '../../../../../components/ui/Buttons/DosenButton';

interface MatchingFields {
  gender: boolean;
  firstGenStudent: boolean;
}

interface AssignMatchPopup1Props {
  openAssignMentor: any;
  handleCloseAssignMentor: any;
  action: string;
  handleOpenFindmentor: any;
  matchingFields: MatchingFields;
  setMatchingFields: any;
  handleSubmitAutoMatch: any;
  maxMatchCountMentee: any;
  maxMatchCountMentor: any;
  setMatchCountMentee: any;
  setMatchCountMentor: any;
  loaderFirstPopup: any;
  selectMentors: React.ReactNode;
  selectValueMentor: boolean;
}

function AssignMatchPopup1({
  openAssignMentor,
  handleCloseAssignMentor,
  action,
  handleOpenFindmentor,
  matchingFields,
  setMatchingFields,
  handleSubmitAutoMatch,
  maxMatchCountMentee,
  maxMatchCountMentor,
  setMatchCountMentee,
  setMatchCountMentor,
  loaderFirstPopup,
  selectMentors,
  selectValueMentor
}: AssignMatchPopup1Props) {
  const mentorRoleText = GroupBasedRoleFormatter('mentor', 'Mentor');
  const mentorRoleTextLowerCase = mentorRoleText.toLowerCase();
  const menteeRoleText = GroupBasedRoleFormatter('mentee', 'Mentee');
  const menteeRoleTextLowerCase = menteeRoleText.toLowerCase();

  return (
    <Dialog
      open={openAssignMentor}
      onClose={handleCloseAssignMentor}
      fullWidth
      PaperProps={{
        sx: {
          bgcolor: '#1C1C1C',
          backgroundImage: 'none',
          color: '#FDFDFD',
          border: '1px solid #2A2A2A',
          borderRadius: '12px'
        }
      }}
    >
      <CommonModalHeader
        handleCloseModal={handleCloseAssignMentor}
        title={
          action === 'Auto Match'
            ? 'Auto match'
            : action === 'Assign Mentor'
            ? 'Assign a ' + mentorRoleTextLowerCase
            : 'Assign a ' + menteeRoleTextLowerCase
        }
      />

      <DialogContent>
        {/* Auto Match criteria (unchanged) */}
        {action === 'Auto Match' && (
          <>
            <Box>
              <Typography variant="h5" mb={1}>
                Matching criteria
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <InputLabel>Maximum matches per {menteeRoleTextLowerCase} *</InputLabel>
                  <FormControl fullWidth>
                    <TextField
                      fullWidth
                      required
                      type="number"
                      variant="outlined"
                      value={maxMatchCountMentee}
                      id="maxMatchCountMentee"
                      onChange={(e) => setMatchCountMentee(Number(e.target.value))}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <InputLabel>Maximum matches per {mentorRoleTextLowerCase} *</InputLabel>
                  <FormControl fullWidth>
                    <TextField
                      fullWidth
                      required
                      type="number"
                      variant="outlined"
                      value={maxMatchCountMentor}
                      id="maxMatchCountMentor"
                      onChange={(e) => setMatchCountMentor(Number(e.target.value))}
                    />
                  </FormControl>
                </Grid>
              </Grid>
            </Box>
            <Divider className="my-20" />
          </>
        )}

        <Box>
          <Box>
            <InputLabel>
              Select {action === 'Assign Mentor' ? mentorRoleText : menteeRoleText}
            </InputLabel>
            {selectMentors}
          </Box>
        </Box>
      </DialogContent>

      <DialogActions>
        {/* Manual tab actions */}
        {action !== 'Auto Match' && (
          <DosenButton onClick={handleOpenFindmentor} disabled={!selectValueMentor}>
            Assign
            {action === 'Assign Mentor' && ' ' + mentorRoleText}
            {action === 'Assign Mentee' && ' ' + menteeRoleText}
          </DosenButton>
        )}

        {/* Auto Match actions (unchanged) */}
        {action === 'Auto Match' && (
          <DosenButton fullWidth loading={loaderFirstPopup} loadingText="Searching..." onClick={handleSubmitAutoMatch}>
            Search Auto Matches
          </DosenButton>
        )}
      </DialogActions>
    </Dialog>
  );
}

export default AssignMatchPopup1;
